import { ApiMethod } from 'services/api';
import { useRestMutation } from 'utils/hooks/api/useRestMutation';

export const ABORT_CAMPAIGN_URL = '/campaigns/abort';

export const useAbortCampaignMutation = () => {
  const { isLoading, mutate, error } = useRestMutation(ABORT_CAMPAIGN_URL, ApiMethod.post);
  return { isLoading, mutate, error };
};
